export const hcpConvertor = (hcp: string = "") => {
  console.log("hcpConvertor", hcp);
  if (!Boolean(hcp)) return "";
  return hcp;
};
